import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, ExternalLink, ArrowRight } from "lucide-react";
import { useSEO } from "@/lib/seo";

// Common thank-you destination for every successful lead submission across the site.
export default function ThankYou() {
  const { state } = useLocation();
  const officialUrl = state?.officialUrl || null;
  const projectName = state?.projectName || null;

  useSEO({ title: "Thank You", description: "We've received your requirement. Our advisory team will be in touch shortly.", path: "/thank-you" });

  return (
    <div className="ec-container py-24 sm:py-28">
      <div className="max-w-xl mx-auto text-center" data-testid="thank-you">
        <div className="mx-auto mb-6 grid place-items-center h-16 w-16 rounded-full bg-primary/10">
          <CheckCircle2 className="h-9 w-9 text-primary" aria-hidden />
        </div>
        <h1 className="font-display text-3xl sm:text-4xl text-foreground">Thank you. We've received your requirement.</h1>
        <p className="mt-4 text-muted-foreground text-lg">
          Our property advisory team will review your requirement and get back to you with relevant opportunities.
        </p>

        {officialUrl && (
          <div className="mt-8 rounded-lg border border-border bg-white p-6">
            <p className="text-sm text-muted-foreground">
              Your {projectName ? `${projectName} ` : ""}brochure is on its way to you. Meanwhile, view the official project details:
            </p>
            <a href={officialUrl} target="_blank" rel="noreferrer" data-testid="thankyou-official-link"
              className="mt-4 inline-flex items-center justify-center gap-2 h-11 px-5 rounded-md bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90 transition-colors">
              <ExternalLink className="h-4 w-4" aria-hidden /> View Official Project Details
            </a>
          </div>
        )}

        <div className="mt-9 flex flex-wrap justify-center gap-3">
          <Link to="/projects" data-testid="thankyou-explore"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90 transition-colors">
            Explore Projects <ArrowRight className="h-4 w-4" aria-hidden />
          </Link>
          <Link to="/" data-testid="thankyou-home"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-primary text-primary text-sm font-semibold hover:bg-primary/5 transition-colors">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
